import React from "react";

export default function MySQL_FIND_IN_SET() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_FIND_IN_SET</h1>
      <p>This is the MySQL_FIND_IN_SET component generated from the SQL JSON.</p>
    </div>
  );
}
